import React from 'react'
import ImagesUploaderField from '../../../../components/ImagesUploaderField'
import { getEdit, getGroupModel, getModule } from '../../selectors'
import { getUser } from '../../../MainPage/selectors'
import { getFormValues } from 'redux-form'
import { OBJECT_FORM } from './Form'
import { connect } from 'react-redux'
import _ from "lodash";
import moment from "moment";
import withQuery from "with-query";


const LogoPicker = props => {
    const images = _.get(props, `moduleData.${props.field.path}`) || []
    const logo = images[0]
    const fullDate = logo && moment(logo.date).format('YYYY-MM-DD_HH-mm-ss')
    return (
        <div style={{padding: '5px'}}>
            {
                logo && (
                    <div className="SidebarContent-logo-container" style={{border: '1px dashed #838383'}}>
                        <img
                            alt={'fsdgfsd'}
                            className="SidebarContent-logo"
                            src={withQuery(`/image/${fullDate}_${logo.name}`, {accessId: props.accessId, groupModelId: props.groupModel && props.groupModel.id})}
                        />
                    </div>
                )
            }
            <ImagesUploaderField
                {...props}
                module={props.module}
                user={props.user}
            />
        </div>
    )
}


const mapStateToProps = (state) => ({
    module: getModule(state),
    user: getUser(state),
    accessId: getEdit(state).accessId,
    groupModel: getGroupModel(state),
    moduleData: getFormValues(OBJECT_FORM)(state)
})

export default connect(mapStateToProps)(LogoPicker)
